/**
 * ハートアニメーションを実行するクラス
 */

export default class HeartAnimation {
  constructor() {
    this.heartAnimationParent = document.querySelector('#js-heart-animation');
  }

  init() {
    if (!this.heartAnimationParent) return;

    // 同時描画終了のフラグ
    const syncEndTiming = true; // true: 全パス同時終了, false: 個別のタイミング

    const paths = this.heartAnimationParent.querySelectorAll('path');

    // 各パスの設定（delay と duration）- 全て同じタイミングに変更
    const pathSettings = [
      { delay: 0, duration: 2 },      // path-1
      { delay: 0, duration: 2 },      // path-2
      { delay: 0, duration: 2 },      // path-3
      { delay: 0, duration: 2 },      // path-4
      { delay: 0, duration: 2 },      // path-5
      { delay: 0, duration: 2 }       // path-6
    ];

    // 各パスの長さを取得
    const pathLengths = [];
    paths.forEach((path, index) => {
      const length = path.getTotalLength();
      pathLengths.push(length);
      // console.log(`Path ${index + 1} length:`, length);
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length;
    });

    if (syncEndTiming) {
      // 最も遅く終わるパスの終了時刻を計算
      let maxEndTime = 0;
      pathSettings.forEach(setting => {
        const endTime = setting.delay + setting.duration;
        if (endTime > maxEndTime) {
          maxEndTime = endTime;
        }
      });
      // 各パスのdurationを調整して同時終了にする
      paths.forEach((path, index) => {
        const setting = pathSettings[index];
        const adjustedDuration = maxEndTime - setting.delay;
        path.style.animationDelay = `${setting.delay}s`;
        path.style.animationDuration = `${adjustedDuration}s`;
        // console.log(`Path ${index + 1}: delay=${setting.delay}s, duration=${adjustedDuration}s, end=${maxEndTime}s`);
      });
    } else {
      // 個別タイミング: CSSで定義された時間をそのまま使用
      paths.forEach((path, index) => {
        const setting = pathSettings[index];
        path.style.animationDelay = `${setting.delay}s`;
        path.style.animationDuration = `${setting.duration}s`;
        // console.log(`Path ${index + 1}: delay=${setting.delay}s, duration=${setting.duration}s`);
      });
    }
  }
}
